// The organization tab strip (spec/dashboard.md section 12.4): Games · Members · Keys · Integrations · Audit, next to the
// games list (Integrations since M7 slice 3).
import { routes } from '../../shell/routes';
import { Tabs } from '../../ui/Tabs';

export type OrgTab = 'games' | 'members' | 'keys' | 'integrations' | 'audit';

export function OrgTabs({ org, value }: { org: string; value: OrgTab }) {
  const items: { key: OrgTab; label: string }[] = [
    { key: 'games', label: 'Games' },
    { key: 'members', label: 'Members' },
    { key: 'keys', label: 'Keys' },
    { key: 'integrations', label: 'Integrations' },
    { key: 'audit', label: 'Audit' },
  ];
  return <Tabs ariaLabel="Organization" value={value} items={items.map((t) => ({ key: t.key, label: t.label, to: routes.orgPage(org, t.key) }))} />;
}
